export default "__VITE_ASSET__0d47ce61__"